import { User } from '@app/core/models/user/user.model';
import { LOGIN_SUCCESS, LOGOUT, AuthAction } from './auth.actions';

export interface State {
  isAuthenticated: boolean;
  user: User | null;
}

export const initialState: State = {
  isAuthenticated: false,
  user: null,
};

export const parseUserPayload = (payload): User => {
  return {
    CPF: payload.nameid,
    email: payload.email,
    fullName: payload.unique_name,
    accessToken: {
      token: payload.accessToken,
      expiresIn: 7200,
    },
    firstAccess: JSON.parse((payload.first_access as string).toLowerCase()),
  };
};

export const reducer = (state = initialState, action: AuthAction): State => {
  switch (action.type) {
    case LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
      };
    }

    case LOGOUT: {
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };
    }

    default: {
      return state;
    }
  }
};

export const isUserAuthenticated = (state: State) => state.isAuthenticated;

export const isFirstUserAccess = (state: State) => state?.user?.firstAccess;
